var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"reload"},[_c('div',{on:{"click":_vm.submit}},[_c('img',{attrs:{"src":"/static/v2/match/reload_icon.png","alt":""}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('global.重新加载')))])]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('global.加载出错，请检查网络连接')))])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-780bc682","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/v2/match/reload.vue
// module id = null
// module chunks = 